export async function getAppVersions(token) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/app-version/list`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}

export async function getPlatforms(token) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/app-version/platforms`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        if (response.ok) {
            return { success: true, data: await response.json() };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}

// Upsert keyed by platform. Backend returns a plain string message, not JSON.
export async function saveAppVersion(token, body) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/app-version/add`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            }
        );
        const message = await response.text();
        if (response.ok) {
            return { success: true, message };
        } else {
            return { success: false, status: response.status, message };
        }
    } catch (error) {
        return { success: false, message: error.message };
    }
}
